module.exports = __webpack_public_path__ + "img/xiaohongshu.46222531.jpg";